// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.attribute-form {
  margin-top: 24px;
}

.attribute-form-title {
  margin-bottom: 12px;
  font-size: 1.1rem;
}

.attribute-section + .attribute-section {
  margin-top: 20px;
}

.attribute-section-title {
  margin: 0 0 12px;
  font-size: 1rem;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.72);
}

.attribute-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 12px 16px;
}

.attribute-field {
  width: 100%;
}

.boolean-field {
  display: flex;
  align-items: center;
  min-height: 56px;
}

.multi-enum-field {
  grid-column: 1/-1;
  padding-top: 4px;
}

.multi-enum-label {
  display: block;
  font-size: 14px;
  margin-bottom: 8px;
  color: rgba(0, 0, 0, 0.7);
}

.multi-enum-checkboxes {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 20px;
}

.range-field {
  grid-column: 1/-1;
  padding-top: 4px;
  min-height: 72px;
}

.range-label {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  margin-bottom: 12px;
  color: rgba(0, 0, 0, 0.7);
}

.range-value {
  font-weight: 600;
  color: rgba(0, 0, 0, 0.87);
}

.field-error {
  color: #f44336;
  font-size: 12px;
  margin: 4px 0 0;
}

.range-field.field-invalid .range-label {
  color: #f44336;
}

:host ::ng-deep .attribute-range-slider.ngx-slider {
  margin: 8px 0 16px;
}
:host ::ng-deep .attribute-range-slider.ngx-slider .ngx-slider-bar {
  background: #e0e0e0;
  height: 4px;
}
:host ::ng-deep .attribute-range-slider.ngx-slider .ngx-slider-selection {
  background: #3f51b5;
}
:host ::ng-deep .attribute-range-slider.ngx-slider .ngx-slider-pointer {
  width: 18px;
  height: 18px;
  top: -8px;
  background: #3f51b5;
  border: 2px solid #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
}
:host ::ng-deep .attribute-range-slider.ngx-slider .ngx-slider-pointer:after {
  display: none;
}
:host ::ng-deep .attribute-range-slider.ngx-slider .ngx-slider-bubble {
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/attribute-form/attribute-form.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;;AAEA;EACE,mBAAA;EACA,iBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;AACF;;AAEA;EACE,aAAA;EACA,2DAAA;EACA,cAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,iBAAA;EACA,gBAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,aAAA;AACF;;AAEA;EACE,iBAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;AACF;;AAEA;EACE,gBAAA;EACA,0BAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,eAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,kBAAA;AACF;AACE;EACE,mBAAA;EACA,WAAA;AACJ;AAEE;EACE,mBAAA;AAAJ;AAGE;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,mBAAA;EACA,sBAAA;EACA,yCAAA;AADJ;AAIE;EACE,aAAA;AAFJ;AAKE;EACE,eAAA;AAHJ","sourcesContent":[".attribute-form {\n  margin-top: 24px;\n}\n\n.attribute-form-title {\n  margin-bottom: 12px;\n  font-size: 1.1rem;\n}\n\n.attribute-section + .attribute-section {\n  margin-top: 20px;\n}\n\n.attribute-section-title {\n  margin: 0 0 12px;\n  font-size: 1rem;\n  font-weight: 600;\n  color: rgba(0, 0, 0, 0.72);\n}\n\n.attribute-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 12px 16px;\n}\n\n.attribute-field {\n  width: 100%;\n}\n\n.boolean-field {\n  display: flex;\n  align-items: center;\n  min-height: 56px;\n}\n\n.multi-enum-field {\n  grid-column: 1 / -1;\n  padding-top: 4px;\n}\n\n.multi-enum-label {\n  display: block;\n  font-size: 14px;\n  margin-bottom: 8px;\n  color: rgba(0, 0, 0, 0.7);\n}\n\n.multi-enum-checkboxes {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px 20px;\n}\n\n.range-field {\n  grid-column: 1 / -1;\n  padding-top: 4px;\n  min-height: 72px;\n}\n\n.range-label {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  font-size: 14px;\n  margin-bottom: 12px;\n  color: rgba(0, 0, 0, 0.7);\n}\n\n.range-value {\n  font-weight: 600;\n  color: rgba(0, 0, 0, 0.87);\n}\n\n.field-error {\n  color: #f44336;\n  font-size: 12px;\n  margin: 4px 0 0;\n}\n\n.range-field.field-invalid .range-label {\n  color: #f44336;\n}\n\n:host ::ng-deep .attribute-range-slider.ngx-slider {\n  margin: 8px 0 16px;\n\n  .ngx-slider-bar {\n    background: #e0e0e0;\n    height: 4px;\n  }\n\n  .ngx-slider-selection {\n    background: #3f51b5;\n  }\n\n  .ngx-slider-pointer {\n    width: 18px;\n    height: 18px;\n    top: -8px;\n    background: #3f51b5;\n    border: 2px solid #fff;\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);\n  }\n\n  .ngx-slider-pointer:after {\n    display: none;\n  }\n\n  .ngx-slider-bubble {\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
